import React from 'react';
import GallectionDeviationManager from '../../Deviations/DeviationManager/GallectionDeviationManager';
import GallectionSidebar from './GallectionSidebar';

export type Props = {};

export class GallectionContentManager extends React.Component<Props> {
  render() {
    return (
      <GallectionDeviationManager sideBarContent={<GallectionSidebar />} />
    );
  }
}

export default GallectionContentManager;
